export default {
  title: 'パスワード再設定',
  newPassword: '新しいパスワードを入力してください',
  newPasswordPlaceholder: 'パスワードは8文字以上で英字と数字を含める必要があります',
  confirmPassword: '新しいパスワードを再度入力してください',
  confirmPasswordPlaceholder: '入力してください',
  submit: '確認',
  passwordRequired: '新しいパスワードを入力してください',
  confirmPasswordRequired: '新しいパスワードを確認してください',
  passwordInvalid: 'パスワードは少なくとも8文字、文字と数字を含む必要があります',
  passwordMismatch: '入力されたパスワードが一致しません',
  tokenMissing: '申し訳ございません。アクセス権限がありません。オーナー/管理者に連絡してください。',
  resetSuccess: 'パスワードのリセットが完了しました。再度ログインしてご利用ください。',
  resetFailed: 'パスワードの再設定に失敗しました',
};